module.exports = __webpack_public_path__ + "img/Animales-KX5200.422544a6.png";